import React from "react"

import { SearchInlineIconWrapper } from "@/components/SearchInlineIconWrapper"
import { YoutubeIcon } from "@/components/YoutubeIcon"

export const YoutubeInlineRightSection = () => (
    <SearchInlineIconWrapper>
        <YoutubeIcon />
    </SearchInlineIconWrapper>
)
